const ModuleContactPage = () => {
  return (
    <div className='pt-28 md:pt-28 px-4 md:px-8'>
      <div className='text-center uppercase font-extrabold text-[40px] leading-[85%] -mt-[3px] tracking-tighter font-abcd text-[#1E1E1E] md:mb-8'>
        CONTACT
      </div>
      <div className='text-[#1E1E1E] mb-20 font-swinton text-[16px] grid grid-cols-12'>
        <div className='mb-6 col-span-12 lg:col-span-5'>
          <p className={`leading-[100%] tracking-[-0.05em]`}>
            Art Basel Awards seek to support the future of the industry by democratically honoring those who move and
            make art from vision to reality. The first of its kind, Art Basel Awards span the full spectrum of artistic
            and cultural impact, covering nine categories
          </p>
        </div>
        <div className='mb-6 col-span-12 lg:col-span-2 lg:col-start-9'>
          <p className={`leading-[100%] tracking-[-0.05em]`}>General</p>
          <p className={`leading-[100%] tracking-[-0.05em]`}>(+44) 07841907047</p>
        </div>
        <div className='col-span-12 lg:col-span-2 lg:col-start-12'>
          <p className={`leading-[100%] tracking-[-0.05em]`}>Social</p>
          <p className={`leading-[100%] tracking-[-0.05em]`}><a href='https://www.instagram.com/artbasel.awards/?hl=en' target='_blank' rel='noopener noreferrer'>Instagram</a></p>
        </div>
      </div>

    </div>
  )
}

export default ModuleContactPage
